/* eslint-disable quotes */
/* eslint-disable semi */
import httpClient from '@/utils/http-client.js';
import { storeActions } from '@store/actions.constants';
import { storeMutations } from '@store/mutations.constants';

const userActions = {
  [storeActions.createVsm]: ({ commit }, payLoad) => {
    console.log(payLoad);
    return httpClient.post('/vsm/addVsm', payLoad).then(
      (res) => {
        console.log(res);

        commit(storeMutations.vsmMutation, res);
        return res;
      },
      (err) => {
        commit(storeMutations.vsmMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getVsmList]: ({ commit }, payLoad) => {
    let url=`/vsm/getVsmList?page=${payLoad.page}&limit=${payLoad.limit}`
    let search
    if(payLoad.sort) url+=`&sort={"${payLoad.sort}":"${payLoad.desc?-1:1}"}`
    if(payLoad.search){
    search = {search:payLoad.search}
    }
    else{
      search = {}
    }
    return httpClient
      .post(
        url,                                                                    
        search,
      ).then(
        (res) => {
          commit(storeMutations.setVsmMutation, res);
          return res;
        },
        (err) => {
          commit(storeMutations.setVsmMutation, err);
          return err.response;
        },
      );
     
     
  },
  [storeActions.getVsmById]: ({ commit }, payLoad) => {
    console.log(payLoad.id);
    return httpClient.get('/vsm/getVsmById/' + payLoad.id).then(
      (res) => {
        console.log(res);

        commit(storeMutations.vsmMutation, res);
        return res;
      },
      (err) => {
        commit(storeMutations.vsmMutation, err);
        return err.response;
      },
    );
  },

  [storeActions.updateVsmById]: ({ commit }, payLoad) => {
    console.log(payLoad);
    return httpClient.post('/vsm/updateVsm/'+payLoad.vsmId, payLoad).then(
      (res) => {
        console.log(res);

        // commit(storeMutations.designationMutation, res);
        return res;
      },
      (err) => {
        // commit(storeMutations.designationMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getDomain]: ({ commit }, payLoad) => {
    let url=`/domain/get?page=${payLoad.page}&limit=${payLoad.limit}`
    // if(payLoad.sort) url+=`&sort={"${payLoad.sort}":"${payLoad.desc?-1:1}"}`
    // if(payLoad.search)url+=`&search=${payLoad.search}`
    return httpClient
      .get(
        url,                                                                    
        payLoad,
      ).then(
        (res) => {
          commit(storeMutations.setDomainMutation, res);
          return res;
        },
        (err) => {
          commit(storeMutations.setDomainMutation, err);
          return err.response;
        },
      );
     
     
  },
  [storeActions.getDomainById]: ({ commit }, payLoad) => {
    console.log(payLoad.id);
    return httpClient.get('/domain/getById/' + payLoad.id).then(
      (res) => {
        console.log(res);

        commit(storeMutations.domainMutation, res);
        return res;
      },
      (err) => {
        commit(storeMutations.domainMutation, err);
        return err.response;
      },
    );
  },

  [storeActions.updateDomainById]: ({ commit }, payLoad) => {
    console.log(payLoad);
    return httpClient.post('/domain/update', payLoad).then(
      (res) => {
        console.log(res);

        // commit(storeMutations.domainMutation, res);
        return res;
      },
      (err) => {
        // commit(storeMutations.domainMutation, err);
        return err.response;
      },
    );
  },
};
export default { ...userActions };